/**
 * Cross-platform Ed25519 wrapper used by the demo.
 *
 * The common code deals with keys as opaque byte arrays:
 * - public keys are encoded as X.509 SubjectPublicKeyInfo (SPKI) bytes (JVM `PublicKey.encoded`)
 * - private keys are platform-specific:
 *   - JVM: PKCS#8 bytes (JVM `PrivateKey.encoded`)
 *   - JS: raw secretKey bytes returned by TweetNaCl (64 bytes)
 *
 * Wire identity:
 * - peerId = base64url(SPKI public key bytes)
 */
package com.oasisfeng.invaluable.identity

data class KeyPairBytes(
    val publicKeySpki: ByteArray,
    val privateKeyBytes: ByteArray,
)

expect object Ed25519 {
    fun generateKeyPair(): KeyPairBytes
    fun sign(message: ByteArray, privateKeyBytes: ByteArray): ByteArray
    fun verify(message: ByteArray, signature: ByteArray, publicKeySpki: ByteArray): Boolean

    /**
     * The raw 32-byte Ed25519 secret seed carried by [privateKeyBytes] (whose outer encoding is platform-specific:
     * PKCS#8 on JVM, the 64-byte TweetNaCl secretKey on JS). Used by [IdentityBox] to derive the Curve25519 secret.
     */
    fun seed(privateKeyBytes: ByteArray): ByteArray
}
